import React from "react";
import InvisibleCharacterGenerator from "../Pages/InvisibleCharacterGenerator";
// import Table from 'react-bootstrap/Table';
import { useTranslation } from "react-i18next";

const Home = () => {
    const { t } = useTranslation();
    return (
        <div className="page-content container">

            <div className="main-container">
                <h1 className="tool-txt-gnt">{t("welcome")}</h1>
                <InvisibleCharacterGenerator />
            </div>


            {/* Layout with 3 columns using Bootstrap grid */}
            <div className="row">
                {/* <div className="col-md-3 col-sm-12 mb-4">
                    <h2>Column 1</h2>
                    <p>Content for column 1</p>
                </div> */}
                <div className="col-md-12 col-sm-12 mb-4">
                    {/* <h1 className="home-h1-hd">Blank Text</h1> */}


                    <h2 className="home-h2-hd">{t("introduction_blank_text")}</h2>
                    <p className="home-p1">
                        {t("introduction_blank_text_description")}
                    </p>

                    <h2 className="home-h2-hd">{t("what_is_blank_character_generator")}</h2>
                    <p className="home-p1">
                        {t("what_is_blank_character_generator_description")}
                    </p>


                    <h2 className="home-h2-hd">{t("how_to_generate_empty_text")}</h2>
                    <p className="home-p1">
                        {t("how_to_generate_empty_text_description")}
                    </p>
                    <p className="home-p1">
                        <b>{t("step_1_label")}</b> {t("step_1_description")}
                    </p>
                    <p className="home-p1">
                        <b>{t("step_2_label")}</b> {t("step_2_description")}
                    </p>
                    <p className="home-p1">
                        <b>{t("step_3_label")}</b> {t("step_3_description")}
                    </p>
                    <p className="home-p1">
                        <b>{t("step_4_label")}</b> {t("step_4_description")}
                    </p>

                    <h2 className="home-h2-hd">{t("features_of_blank_text_generator")}</h2>

                    <h3 className="home-h3-hd">{t("feature_free_to_use_title")}</h3>
                    <p className="home-p1">
                        {t("feature_free_to_use_description")}
                    </p>

                    <h3 className="home-h3-hd">{t("feature_user_friendly_title")}</h3>
                    <p className="home-p1">
                        {t("feature_user_friendly_description")}
                    </p>

                    <h3 className="home-h3-hd">{t("feature_device_compatibility_title")}</h3>
                    <p className="home-p1">
                        {t("feature_device_compatibility_description")}
                    </p>

                    <h3 className="home-h3-hd">{t("feature_instant_result_title")}</h3>
                    <p className="home-p1">
                        {t("feature_instant_result_description")}
                    </p>


                    <h3 className="home-h3-hd">{t("feature_unlimited_usage_title")}</h3>
                    <p className="home-p1">
                        {t("feature_unlimited_usage_description")}
                    </p>


                    <h3 className="home-h3-hd">{t("feature_multilingual_title")}</h3>
                    <p className="home-p1">
                        {t("feature_multilingual_description")}
                    </p>


                    {/* <h3 className="home-h3-hd">Multilingual</h3>
                    <p className="home-p1">
                        If you don't understand English, don't worry, our generator provides a multilingual
                        feature by which you can use it in any language , that's why people who speak different
                        languages can use it . so it doesn't matter where you’re from or which language you
                        speak. You can use it easily. It allows users around any part of the world to use the tool
                        in native language.
                    </p> */}


                    <h3 className="home-h3-hd">{t("feature_no_installation_title")}</h3>
                    <p className="home-p1">
                        {t("feature_no_installation_description")}
                    </p>

                    {/* <h3 className="home-h3-hd">No installation</h3>
                    <p className="home-p1">
                        Our blank text generator requires no installation. The generator is online so you can
                        start using it without needing to download any software or apps. Simply you can visit the
                        website or platform, and start generating invisible text immediately.
                    </p> */}


                    <h3 className="home-h3-hd">{t("feature_no_signup_title")}</h3>
                    <p className="home-p1">
                        {t("feature_no_signup_description")}
                    </p>


                    {/* <h3 className="home-h3-hd">No signup required</h3>
                    <p className="home-p1">
                        Our invisible text generator does not require any registration or sign up for its usage.
                        You can start using it without going through any identification process. You can easily
                        access the tool without logging in or managing accounts- just open the tool and start
                        using.it will not ask you to provide any type of information for its usage
                    </p> */}


                    <h2 className="home-h2-hd">{t("creative_uses_title")}</h2>

                    <h3 className="home-h3-hd">{t("invisible_names_title")}</h3>
                    <p className="home-p1">
                        {t("invisible_names_description")}
                    </p>



                    {/* <h2 className="home-h2-hd">Creative Uses of invisible characters in daily life</h2>

                    <h3 className="home-h3-hd">Invisible Names in Games</h3>
                    <p className="home-p1">
                        Invisible letters can be used creatively to create invisible names in games. This allows
                        you to have a name that appears hidden to others but creates a unique aesthetic. If you
                        want to play without anyone knowing your real name or identity, using empty text also
                        helps you to protect your personal information. Invisible names also add fun in your
                        gaming experience
                    </p> */}



                    <h3 className="home-h3-hd">{t("unique_captions_title")}</h3>
                    <p className="home-p1">
                        {t("unique_captions_description")}
                    </p>



                    {/* <h3 className="home-h3-hd">Unique Captions</h3>
                    <p className="home-p1">
                        Blank text can be creatively used in captions on anywhere you share content. Using
                        empty text in captions helps you break free from traditional text formatting, and allow
                        you to create unique and thoughtful content that grabs attention in a creative way
                    </p> */}

                    <h3 className="home-h3-hd">{t("social_media_title")}</h3>
                    <p className="home-p1">
                        {t("social_media_description")}
                    </p>


                    {/* <h3 className="home-h3-hd">Social media</h3>
                    <p className="home-p1">
                        Blank text can be a fun and creative way to enhance your social media presence. You
                        can use invisible text in your social media username to make it hide from other that
                        makes your profile attractive you can also used it in your post captions,profiles
                        bio,comments,etc
                    </p> */}


                    <h3 className="home-h3-hd">{t("privacy_security_title")}</h3>
                    <p className="home-p1">
                        {t("privacy_security_description")}
                    </p>



                    {/* <h3 className="home-h3-hd">Privacy and security</h3>
                    <p className="home-p1">
                        If you want to make your social media accounts more safe and secure then use hidden
                        text instead of simple text on social media or various platforms to make your personal
                        or sensitive information secure . It can be used in password to add complexity which
                        helps you to improve the overall security of your login.
                    </p> */}


                    <h3 className="home-h3-hd">{t("development_programming_title")}</h3>
                    <p className="home-p1">
                        {t("development_programming_description")}
                    </p>




                    {/* <h3 className="home-h3-hd">Development and programming</h3>
                    <p className="home-p1">
                        Using hidden text plays an important role in development and programming. Developers
                        can use invisible text creatively to solve problems, format code, and even hide
                        information. Blank text can be used to create files or folders with invisible names on
                        some operating systems.
                    </p> */}



                    <h2 className="home-h2-hd">{t("how_to_send_blank_message_title")}</h2>
                    <p className="home-p1">
                        {t("how_to_send_blank_message_description")}
                    </p>





                    {/* <h2 className="home-h2-hd">How to send a blank message on whatsapp? </h2>
                    <p className="home-p1">
                        You can send a blank message on whatsapp very easily by following some simple steps
                        that are given below :<br />
                        First open the blank text generator, then click on the generate an invisible text button to
                        make a hidden text.now copy the generated blank space text and paste it in your
                        whatsapp text box now you can send it to anyone according to your desire.
                    </p> */}


                    <h2 className="home-h2-hd">{t("how_to_send_blank_comment_title")}</h2>
                    <p className="home-p1">
                        {t("how_to_send_blank_comment_description")}
                    </p>


                    {/* <h2 className="home-h2-hd">How to send blank comments on instagram? </h2>
                    <p className="home-p1">
                        You can send blank comments on instagram by following a simple way.
                        First, just open the blank space text generator to create an invisible character.
                        Now copy the blank character provided by the generator. Then go to instagram, tap the
                        comment section, and paste the hidden text in your comment. Once you paste the blank
                        text then click on the send button to send a blank comment in the comment box. By
                        using this method you can easily send a blank comment to anyone.

                    </p> */}




                    <h2 className="home-h2-hd">{t("faqs_title")}</h2>

                    <h3 className="home-h3-hd">{t("how_to_send_blank_comment_title")}</h3>
                    <p className="home-p1">
                        {t("how_to_send_blank_comment_description_step_1")}
                    </p>
                    <p className="home-p1">
                        <b>{t("step_1")}: </b>{t("open_blank_text_generator")}
                    </p>
                    <p className="home-p1">
                        <b>{t("step_2")}: </b>{t("click_generate_hidden_text_button")}
                    </p>
                    <p className="home-p1">
                        <b>{t("step_3")}: </b>{t("generator_creates_invisible_text")}
                    </p>
                    <p className="home-p1">
                        <b>{t("step_4")}: </b>{t("copy_and_paste_text")}
                    </p>

                    <h3 className="home-h3-hd">{t("is_blank_text_compatible_title")}</h3>
                    <p className="home-p1">
                        {t("is_blank_text_compatible_description")}
                    </p>

                    <h3 className="home-h3-hd">{t("is_invisible_character_generator_safe_title")}</h3>
                    <p className="home-p1">
                        {t("is_invisible_character_generator_safe_description")}
                    </p>



                    {/* <h2 className="home-h2-hd">FAQ’S</h2>
                    <h3 className="home-h3-hd">How to send blank comments on instagram? </h3>
                    <p className="home-p1">
                        You can use a blank text generator easily with just a few simple steps that are given below:
                    </p>
                    <p className="home-p1">
                        <b> Step 1:</b>  Open the blank text generator.
                    </p>
                    <p className="home-p1">
                        <b> Step 2:</b>  click on the generate a hide text button to generate a hidden text.
                    </p>
                    <p className="home-p1">
                        <b> Step 3:</b>  The generator will immediately create invisible text and copy it to your clipboard.
                    </p>
                    <p className="home-p1">
                        <b> Step 4:</b>  Copy the text and Paste it wherever you need.
                    </p>


                    <h3 className="home-h3-hd">Is blank text compatible with all platforms?</h3>
                    <p className="home-p1">
                        Yes, blank text is compatible with all platforms. In social media platforms such as
                        instagram, facebook, twitter and tiktok the blank space text can be used in comments,
                        captions, and video description. Similarly, in messenger, whatsapp and telegram,
                        invisible font text works well in messages, group chats, and statuses.

                    </p>


                    <h3 className="home-h3-hd">Is invisible character generator safe to use?</h3>
                    <p className="home-p1">
                        Yes, a hidden text generator is generally safe to use, you can use it without giving any
                        personal information to it . it will not ask you to give any sort of information for its usage
                        .Just open it and use it whenever you want.
                    </p> */}


                    {/* <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>Unicode</th>
                                <th>Description</th>
                                <th>Html</th>
                                <th>Example</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>U+0020</td>
                                <td>
                                    <p>Space</p>
                                </td>
                                <td>&amp;#32;</td>
                                <td className="codeClick">⁢[ ]</td>
                            </tr>
                            <tr>
                                <td>U+00A0</td>
                                <td>
                                    <p>No-Break Space</p>
                                </td>
                                <td>&amp;nbsp;</td>
                                <td className="codeClick">[ ]</td>
                            </tr>
                            <tr>
                                <td>U+2000</td>
                                <td>
                                    <p>En Quad</p>
                                </td>
                                <td>&amp;#8192;</td>
                                <td className="codeClick">⁢[ ]</td>
                            </tr>
                            <tr>
                                <td>U+2001</td>
                                <td>
                                    <p>Em Quad</p>
                                </td>
                                <td>&amp;#8193;</td>
                                <td className="codeClick">⁢[ ]</td>
                            </tr>
                            <tr>
                                <td>U+2002</td>
                                <td>
                                    <p>En Space</p>
                                </td>
                                <td>&amp;#8194;</td>
                                <td className="codeClick">⁢[ ]</td>
                            </tr>
                            <tr>
                                <td>U+2004</td>
                                <td>
                                    <p>Three-Per-Em Space</p>
                                </td>
                                <td>&amp;#8196;</td>
                                <td className="codeClick">⁢[ ]</td>
                            </tr>
                            <tr>
                                <td>U+2005</td>
                                <td>
                                    <p>Four-Per-Em Space</p>
                                </td>
                                <td>&amp;#8197;</td>
                                <td className="codeClick">⁢[ ]</td>
                            </tr>
                            <tr>
                                <td>U+2006</td>
                                <td>
                                    <p>Six-Per-Em Space</p>
                                </td>
                                <td>&amp;#8198;</td>
                                <td className="codeClick">⁢[ ]</td>
                            </tr>
                            <tr>
                                <td>U+2007</td>
                                <td>
                                    <p>Figure Space</p>
                                </td>
                                <td>&amp;#8199;</td>
                                <td className="codeClick">⁢[ ]</td>
                            </tr>
                            <tr>
                                <td>U+2008</td>
                                <td>
                                    <p>Punctuation Space</p>
                                </td>
                                <td>&amp;#8200;</td>
                                <td className="codeClick">⁢[ ]</td>
                            </tr>
                            <tr>
                                <td>U+2009</td>
                                <td>
                                    <p>Thin Space</p>
                                </td>
                                <td>&amp;#8201;</td>
                                <td className="codeClick">⁢[ ]</td>
                            </tr>
                            <tr>
                                <td>U+200A</td>
                                <td>
                                    <p>Hair Space</p>
                                </td>
                                <td>&amp;#8202;</td>
                                <td className="codeClick">⁢[ ]</td>
                            </tr>
                            <tr>
                                <td>U+2028</td>
                                <td>
                                    <p>Line Separator</p>
                                </td>
                                <td>&amp;#8232;</td>
                                <td className="codeClick">⁢[]</td>
                            </tr>
                            <tr>
                                <td>U+205F</td>
                                <td>
                                    <p>Medium Mathematical Space</p>
                                </td>
                                <td>&amp;#8287;</td>
                                <td className="codeClick">⁢[ ]</td>
                            </tr>
                            <tr>
                                <td>U+3000</td>
                                <td>
                                    <p>Ideographic Space</p>
                                </td>
                                <td>&amp;#12288;</td>
                                <td className="codeClick">⁢[　]</td>
                            </tr>
                            <tr>
                                <td>U+2003</td>
                                <td>
                                    <p>Em Space</p>
                                </td>
                                <td>&amp;#8195;</td>
                                <td className="codeClick">⁢[ ]</td>
                            </tr>
                            <tr>
                                <td>U+25A0</td>
                                <td>
                                    <p>Black Square</p>
                                </td>
                                <td>&amp;#9632;</td>
                                <td className="codeClick">⁢[■]</td>
                            </tr>
                            <tr>
                                <td>U+0009</td>
                                <td>
                                    <p>Horizontal Tab</p>
                                </td>
                                <td>&amp;#9;</td>
                                <td className="codeClick">⁢[ ]</td>
                            </tr>
                            <tr>
                                <td>U+000A</td>
                                <td>
                                    <p>Line Feed</p>
                                </td>
                                <td>&amp;#10;</td>
                                <td className="codeClick">⁢[ ]</td>
                            </tr>
                            <tr>
                                <td>U+000C</td>
                                <td>
                                    <p>Form Feed</p>
                                </td>
                                <td>&amp;#12;</td>
                                <td className="codeClick">⁢[ ]</td>
                            </tr>
                            <tr>
                                <td>U+001C</td>
                                <td>
                                    <p>File Separator</p>
                                </td>
                                <td>&amp;#28;</td>
                                <td className="codeClick">⁢[ ]</td>
                            </tr>
                            <tr>
                                <td>U+200B</td>
                                <td>
                                    <p>Zero-Width Space</p>
                                </td>
                                <td>&amp;#8203;</td>
                                <td className="codeClick">⁢[​]</td>
                            </tr>
                            <tr>
                                <td>U+200C</td>
                                <td>
                                    <p>Zero-Width Non-Joiner</p>
                                </td>
                                <td>&amp;#8204;</td>
                                <td className="codeClick">⁢[‌]</td>
                            </tr>
                            <tr>
                                <td>U+2060</td>
                                <td>
                                    <p>Word Joiner</p>
                                </td>
                                <td>&amp;#8288;</td>
                                <td className="codeClick">⁢[⁠]</td>
                            </tr>
                            <tr>
                                <td>U+2061</td>
                                <td>
                                    <p>Word Separator</p>
                                </td>
                                <td>&amp;#8289;</td>
                                <td className="codeClick">⁢[⁡]</td>
                            </tr>
                            <tr>
                                <td>U+2062</td>
                                <td>
                                    <p>Paragraph Separator</p>
                                </td>
                                <td>&amp;#8290;</td>
                                <td className="codeClick">[⁢]</td>
                            </tr>
                            <tr>
                                <td>U+00AD</td>
                                <td>
                                    <p>Soft Hyphen</p>
                                </td>
                                <td>&amp;#173;</td>
                                <td className="codeClick">[­]</td>
                            </tr>
                            <tr>
                                <td>U+034F</td>
                                <td>
                                    <p>Combining Grapheme Joiner</p>
                                </td>
                                <td>&amp;#847;</td>
                                <td className="codeClick">[­]</td>
                            </tr>
                            <tr>
                                <td>U+061C</td>
                                <td>
                                    <p>Arabic Letter Mark</p>
                                </td>
                                <td>&amp;#1564;</td>
                                <td className="codeClick">[؜؜؜]</td>
                            </tr>
                            <tr>
                                <td>U+115F</td>
                                <td>
                                    <p>Hangul Choseong Filler</p>
                                </td>
                                <td>&amp;#4447;</td>
                                <td className="codeClick">[ᅟ ]</td>
                            </tr>
                            <tr>
                                <td>U+1160</td>
                                <td>
                                    <p>Hangul Jungseong Filler</p>
                                </td>
                                <td>&amp;#4448;</td>
                                <td className="codeClick">[ᅠ ]</td>
                            </tr>
                            <tr>
                                <td>U+17B4</td>
                                <td>
                                    <p>Khmer Vowel Inherent Aq</p>
                                </td>
                                <td>&amp;#6068;</td>
                                <td className="codeClick">[឴ ]</td>
                            </tr>
                            <tr>
                                <td>U+17B5</td>
                                <td>
                                    <p>Khmer Vowel Inherent Aa</p>
                                </td>
                                <td>&amp;#6069;</td>
                                <td className="codeClick">[឵ ]</td>
                            </tr>
                            <tr>
                                <td>U+180B</td>
                                <td>
                                    <p>FVS1</p>
                                </td>
                                <td>&amp;#6155;</td>
                                <td className="codeClick">[᠋ ]</td>
                            </tr>
                            <tr>
                                <td>U+180C</td>
                                <td>
                                    <p>FVS2</p>
                                </td>
                                <td>&amp;#6156;</td>
                                <td className="codeClick">[᠌ ]</td>
                            </tr>
                            <tr>
                                <td>U+180D</td>
                                <td>
                                    <p>FVS3</p>
                                </td>
                                <td>&amp;#6157;</td>
                                <td className="codeClick">[᠍ ]</td>
                            </tr>
                            <tr>
                                <td>U+180E</td>
                                <td>
                                    <p>MVS</p>
                                </td>
                                <td>&amp;#6158;</td>
                                <td className="codeClick">[᠎ ]</td>
                            </tr>
                            <tr>
                                <td>U+200D</td>
                                <td>
                                    <p>Zero Width Joiner</p>
                                </td>
                                <td>&amp;#8205;</td>
                                <td className="codeClick">[‍ ]</td>
                            </tr>
                            <tr>
                                <td>U+200E</td>
                                <td>
                                    <p>Left-to-Right Mark</p>
                                </td>
                                <td>&amp;#8206;</td>
                                <td className="codeClick">[‎ ]</td>
                            </tr>
                            <tr>
                                <td>U+200F</td>
                                <td>
                                    <p>Right-to-Left Mark</p>
                                </td>
                                <td>&amp;#8207;</td>
                                <td className="codeClick">[‏ ]</td>
                            </tr>
                            <tr>
                                <td>U+202A</td>
                                <td>
                                    <p>Left-to-Right Embedding</p>
                                </td>
                                <td>&amp;#8234;</td>
                                <td className="codeClick">[‪ ]</td>
                            </tr>
                            <tr>
                                <td>U+202B</td>
                                <td>
                                    <p>RLE</p>
                                </td>
                                <td>&amp;#8235;</td>
                                <td className="codeClick">[‫ ]</td>
                            </tr>
                            <tr>
                                <td>U+202C</td>
                                <td>
                                    <p>Pop Directional Formatting</p>
                                </td>
                                <td>&amp;#8236;</td>
                                <td className="codeClick">[‬ ]</td>
                            </tr>
                            <tr>
                                <td>U+202D</td>
                                <td>
                                    <p>Left-to-Reight Override</p>
                                </td>
                                <td>&amp;#8237;</td>
                                <td className="codeClick">[‭ ]</td>
                            </tr>
                            <tr>
                                <td>U+202E</td>
                                <td>
                                    <p>Right-to-Left Override</p>
                                </td>
                                <td>&amp;#8238;</td>
                                <td className="codeClick">[‮ ]</td>
                            </tr>
                            <tr>
                                <td>U+202F</td>
                                <td>
                                    <p>Narrow No-Break Space</p>
                                </td>
                                <td>&amp;#8239;</td>
                                <td className="codeClick">[  ]</td>
                            </tr>
                            <tr>
                                <td>U+2063</td>
                                <td>
                                    <p>Invisible Separator</p>
                                </td>
                                <td>&amp;#8291;</td>
                                <td className="codeClick">[⁣ ]</td>
                            </tr>
                            <tr>
                                <td>U+2064</td>
                                <td>
                                    <p>Invisible Plus</p>
                                </td>
                                <td>&amp;#8292;</td>
                                <td className="codeClick">[⁤ ]</td>
                            </tr>
                            <tr>
                                <td>U+2064</td>
                                <td>
                                    <p>Invisible Plus</p>
                                </td>
                                <td>&amp;#8292;</td>
                                <td className="codeClick">[⁤ ]</td>
                            </tr>
                            <tr>
                                <td>U+2066</td>
                                <td>
                                    <p>LRI</p>
                                </td>
                                <td>&amp;#8294;</td>
                                <td className="codeClick">[⁦ ]</td>
                            </tr>
                            <tr>
                                <td>U+2066</td>
                                <td>
                                    <p>LRI</p>
                                </td>
                                <td>&amp;#8294;</td>
                                <td className="codeClick">[⁦ ]</td>
                            </tr>
                            <tr>
                                <td>U+2067</td>
                                <td>
                                    <p>RLI</p>
                                </td>
                                <td>&amp;#8294;</td>
                                <td className="codeClick">[⁧ ]</td>
                            </tr>
                            <tr>
                                <td>U+2068</td>
                                <td>
                                    <p>FSI</p>
                                </td>
                                <td>&amp;#8296;</td>
                                <td className="codeClick">[⁨ ]</td>
                            </tr>
                            <tr>
                                <td>U+2069</td>
                                <td>
                                    <p>Pop Directional Isolate</p>
                                </td>
                                <td>&amp;#8297;</td>
                                <td className="codeClick">[⁩ ]</td>
                            </tr>
                            <tr>
                                <td>U+206A</td>
                                <td>
                                    <p>Inhibit Symmetric Swapping</p>
                                </td>
                                <td>&amp;#8298;</td>
                                <td className="codeClick">[⁪ ]</td>
                            </tr>
                            <tr>
                                <td>U+2800</td>
                                <td>
                                    <p>Braille Pattern Blank</p>
                                </td>
                                <td>&amp;#10240;</td>
                                <td className="codeClick">[⠀ ]</td>
                            </tr>
                            <tr>
                                <td>U+206B</td>
                                <td>
                                    <p>Activate Symmetric Swapping</p>
                                </td>
                                <td>&amp;#8299;</td>
                                <td className="codeClick">[⁫ ]</td>
                            </tr>
                            <tr>
                                <td>U+206C</td>
                                <td>
                                    <p>Inhibit Arabic Form Shaping</p>
                                </td>
                                <td>&amp;#8300;</td>
                                <td className="codeClick">[⁬ ]</td>
                            </tr>
                            <tr>
                                <td>U+206D</td>
                                <td>
                                    <p>Activate Arabic Form Shaping</p>
                                </td>
                                <td>&amp;#8301;</td>
                                <td className="codeClick">[⁭ ]</td>
                            </tr>
                            <tr>
                                <td>U+206E</td>
                                <td>
                                    <p>National Digit Shapes</p>
                                </td>
                                <td>&amp;#8302;</td>
                                <td className="codeClick">[⁮ ]</td>
                            </tr>
                            <tr>
                                <td>U+206F</td>
                                <td>
                                    <p>Nominal Digit Shapes</p>
                                </td>
                                <td>&amp;#8303;</td>
                                <td className="codeClick">[⁯ ]</td>
                            </tr>
                            <tr>
                                <td>U+2800</td>
                                <td>
                                    <p>Braille Pattern Blank</p>
                                </td>
                                <td>&amp;#10240;</td>
                                <td className="codeClick">[⠀ ]</td>
                            </tr>
                            <tr>
                                <td>U+3164</td>
                                <td>
                                    <p>Hangul Filler</p>
                                </td>
                                <td>&amp;#12644;</td>
                                <td className="codeClick">[ㅤ ]</td>
                            </tr>
                            <tr>
                                <td>U+FE00</td>
                                <td>
                                    <p>Variation Selector-1</p>
                                </td>
                                <td>&amp;#65024;</td>
                                <td className="codeClick">[︀ ]</td>
                            </tr>
                            <tr>
                                <td>U+FE01</td>
                                <td>
                                    <p>Variation Selector-2</p>
                                </td>
                                <td>&amp;#65025;</td>
                                <td className="codeClick">[︁ ]</td>
                            </tr>
                            <tr>
                                <td>U+FE02</td>
                                <td>
                                    <p>Variation Selector-3</p>
                                </td>
                                <td>&amp;#65026;</td>
                                <td className="codeClick">[︂ ]</td>
                            </tr>
                            <tr>
                                <td>U+FE03</td>
                                <td>
                                    <p>Variation Selector-4</p>
                                </td>
                                <td>&amp;#65027;</td>
                                <td className="codeClick">[︃ ]</td>
                            </tr>
                            <tr>
                                <td>U+FE04</td>
                                <td>
                                    <p>Variation Selector-5</p>
                                </td>
                                <td>&amp;#65028;</td>
                                <td className="codeClick">[︄ ]</td>
                            </tr>
                            <tr>
                                <td>U+FE05</td>
                                <td>
                                    <p>Variation Selector-6</p>
                                </td>
                                <td>&amp;#65029;</td>
                                <td className="codeClick">[︅ ]</td>
                            </tr>
                            <tr>
                                <td>U+FE06</td>
                                <td>
                                    <p>Variation Selector-7</p>
                                </td>
                                <td>&amp;#65030;</td>
                                <td className="codeClick">[︆ ]</td>
                            </tr>
                            <tr>
                                <td>U+FE07</td>
                                <td>
                                    <p>Variation Selector-8</p>
                                </td>
                                <td>&amp;#65031;</td>
                                <td className="codeClick">[︇ ]</td>
                            </tr>
                            <tr>
                                <td>U+FE08</td>
                                <td>
                                    <p>Variation Selector-9</p>
                                </td>
                                <td>&amp;#65032;</td>
                                <td className="codeClick">[︈ ]</td>
                            </tr>
                            <tr>
                                <td>U+FE09</td>
                                <td>
                                    <p>Variation Selector-10</p>
                                </td>
                                <td>&amp;#65033;</td>
                                <td className="codeClick">[︉ ]</td>
                            </tr>
                            <tr>
                                <td>U+FE0A</td>
                                <td>
                                    <p>Variation Selector-11</p>
                                </td>
                                <td>&amp;#65034;</td>
                                <td className="codeClick">[︊ ]</td>
                            </tr>
                            <tr>
                                <td>U+FE0B</td>
                                <td>
                                    <p>Variation Selector-12</p>
                                </td>
                                <td>&amp;#65035;</td>
                                <td className="codeClick">[︋ ]</td>
                            </tr>
                            <tr>
                                <td>U+FE0C</td>
                                <td>
                                    <p>Variation Selector-13</p>
                                </td>
                                <td>&amp;#65036;</td>
                                <td className="codeClick">[︌ ]</td>
                            </tr>
                            <tr>
                                <td>U+FE0D</td>
                                <td>
                                    <p>Variation Selector-14</p>
                                </td>
                                <td>&amp;#65037;</td>
                                <td className="codeClick">[︍ ]</td>
                            </tr>
                            <tr>
                                <td>U+FE0E</td>
                                <td>
                                    <p>Variation Selector-15</p>
                                </td>
                                <td>&amp;#65038;</td>
                                <td className="codeClick">[︎ ]</td>
                            </tr>
                            <tr>
                                <td>U+FE0F</td>
                                <td>
                                    <p>Variation Selector-16</p>
                                </td>
                                <td>&amp;#65039;</td>
                                <td className="codeClick">[️ ]</td>
                            </tr>
                            <tr>
                                <td>U+FEFF</td>
                                <td>
                                    <p>Zero Width No-Break Space</p>
                                </td>
                                <td>&amp;#65279;</td>
                                <td className="codeClick">[ ]</td>
                            </tr>
                            <tr>
                                <td>U+FFA0</td>
                                <td>
                                    <p>Halfwidth Hangul Filler</p>
                                </td>
                                <td>&amp;#65216;</td>
                                <td className="codeClick">[ﻀ ]</td>
                            </tr>
                            <tr>
                                <td>U+FFFC</td>
                                <td>
                                    <p>Object Replacement Character</p>
                                </td>
                                <td>&amp;#65532;</td>
                                <td className="codeClick">[￼ ]</td>
                            </tr>
                            <tr>
                                <td>U+133FC</td>
                                <td>
                                    <p>EGYPTIAN HIEROGLYPH Z015B</p>
                                </td>
                                <td>&amp;#80828;</td>
                                <td className="codeClick">[𓮼 ]</td>
                            </tr>
                            <tr>
                                <td>U+1D159</td>
                                <td>
                                    <p>Musical Symbol Null Notehead</p>
                                </td>
                                <td>&amp;#119065;</td>
                                <td className="codeClick">[𝄙 ]</td>
                            </tr>
                            <tr>
                                <td>U+1D173</td>
                                <td>
                                    <p>Musical Symbol Begin Beam</p>
                                </td>
                                <td>&amp;#119187;</td>
                                <td className="codeClick">[𝆓 ]</td>
                            </tr>
                            <tr>
                                <td>U+1D174</td>
                                <td>
                                    <p>Musical Symbol End Beam</p>
                                </td>
                                <td>&amp;#119188;</td>
                                <td className="codeClick">[𝆔 ]</td>
                            </tr>
                            <tr>
                                <td>U+1D175</td>
                                <td>
                                    <p>Musical Symbol Begin Tie</p>
                                </td>
                                <td>&amp;#119189;</td>
                                <td className="codeClick">[𝆕 ]</td>
                            </tr>
                            <tr>
                                <td>U+1D176</td>
                                <td>
                                    <p>Musical Symbol End tie</p>
                                </td>
                                <td>&amp;#119190;</td>
                                <td className="codeClick">[𝆖 ]</td>
                            </tr>
                            <tr>
                                <td>U+1D177</td>
                                <td>
                                    <p>Musical Symbol Begin Slur</p>
                                </td>
                                <td>&amp;#119191;</td>
                                <td className="codeClick">[𝆗 ]</td>
                            </tr>
                            <tr>
                                <td>U+1D178</td>
                                <td>
                                    <p>Musical Symbol End Slur</p>
                                </td>
                                <td>&amp;#119192;</td>
                                <td className="codeClick">[𝆘 ]</td>
                            </tr>
                            <tr>
                                <td>U+1D179</td>
                                <td>
                                    <p>Musical Symbol Begin Phrase</p>
                                </td>
                                <td>&amp;#119193;</td>
                                <td className="codeClick">[𝆙 ]</td>
                            </tr>
                            <tr>
                                <td>U+1D17A</td>
                                <td>
                                    <p>Musical Symbol End Phrase</p>
                                </td>
                                <td>&amp;#119194;</td>
                                <td className="codeClick">[𝆚 ]</td>
                            </tr>
                            <tr>
                                <td>U+E0001</td>
                                <td>
                                    <p>Language Tag</p>
                                </td>
                                <td>&amp;#917505;</td>
                                <td className="codeClick">[󠀁 ]</td>
                            </tr>
                            <tr>
                                <td>U+E0020</td>
                                <td>
                                    <p>Tag Space</p>
                                </td>
                                <td>&amp;#917538;</td>
                                <td className="codeClick">[󠀢 ]</td>
                            </tr>
                            <tr>
                                <td>U+E0021</td>
                                <td>
                                    <p>TAG EXCLAMATION MARK</p>
                                </td>
                                <td>&amp;#917539;</td>
                                <td className="codeClick">[󠀣 ]</td>
                            </tr>
                            <tr>
                                <td>U+E0022</td>
                                <td>
                                    <p>TAG QUOTATION MARK</p>
                                </td>
                                <td>&amp;#917540;</td>
                                <td className="codeClick">[󠀤 ]</td>
                            </tr>
                            <tr>
                                <td>U+E0023</td>
                                <td>
                                    <p>TAG NUMBER SIGN</p>
                                </td>
                                <td>&amp;#917541;</td>
                                <td className="codeClick">[󠀥 ]</td>
                            </tr>
                            <tr>
                                <td>U+E0024</td>
                                <td>
                                    <p>TAG DOLLAR SIGN</p>
                                </td>
                                <td>&amp;#917542;</td>
                                <td className="codeClick">[󠀦 ]</td>
                            </tr>
                            <tr>
                                <td>U+E0025</td>
                                <td>
                                    <p>TAG PERCENT SIGN</p>
                                </td>
                                <td>&amp;#917543;</td>
                                <td className="codeClick">[󠀧 ]</td>
                            </tr>
                            <tr>
                                <td>U+E0026</td>
                                <td>
                                    <p>Tag Ampersand</p>
                                </td>
                                <td>&amp;#917544;</td>
                                <td className="codeClick">[󠀨 ]</td>
                            </tr>
                            <tr>
                                <td>U+E0027</td>
                                <td>
                                    <p>TAG APOSTROPHE</p>
                                </td>
                                <td>&amp;#917545;</td>
                                <td className="codeClick">[󠀩 ]</td>
                            </tr>
                            <tr>
                                <td>U+E0028</td>
                                <td>
                                    <p>TAG LEFT PARENTHESIS</p>
                                </td>
                                <td>&amp;#917546;</td>
                                <td className="codeClick">[󠀪 ]</td>
                            </tr>
                            <tr>
                                <td>U+E0029</td>
                                <td>
                                    <p>TAG RIGHT PARENTHESIS</p>
                                </td>
                                <td>&amp;#917547;</td>
                                <td className="codeClick">[󠀫 ]</td>
                            </tr>
                            <tr>
                                <td>U+E002A</td>
                                <td>
                                    <p>TAG ASTERISK</p>
                                </td>
                                <td>&amp;#917548;</td>
                                <td className="codeClick">[󠀬 ]</td>
                            </tr>
                            <tr>
                                <td>U+E002B</td>
                                <td>
                                    <p>TAG PLUS SIGN</p>
                                </td>
                                <td>&amp;#917549;</td>
                                <td className="codeClick">[󠀭 ]</td>
                            </tr>
                            <tr>
                                <td>U+E002C</td>
                                <td>
                                    <p>TAG COMMA</p>
                                </td>
                                <td>&amp;#917550;</td>
                                <td className="codeClick">[󠀮 ]</td>
                            </tr>
                            <tr>
                                <td>U+E002D</td>
                                <td>
                                    <p>TAG HYPHEN-MINUS</p>
                                </td>
                                <td>&amp;#917551;</td>
                                <td className="codeClick">[󠀯 ]</td>
                            </tr>
                            <tr>
                                <td>U+E002E</td>
                                <td>
                                    <p>Tag Full Stop</p>
                                </td>
                                <td>&amp;#917552;</td>
                                <td className="codeClick">[󠀰 ]</td>
                            </tr>
                            <tr>
                                <td>U+E002F</td>
                                <td>
                                    <p>Tag Solidus</p>
                                </td>
                                <td>&amp;#917553;</td>
                                <td className="codeClick">[󠀱 ]</td>
                            </tr>
                            <tr>
                                <td>U+E0030</td>
                                <td>
                                    <p>TAG DIGIT ZERO</p>
                                </td>
                                <td>&amp;#917554;</td>
                                <td className="codeClick">[󠀲 ]</td>
                            </tr>
                        </tbody>
                    </Table> */}





                </div>
                {/* <div className="col-md-3 col-sm-12 mb-4">
                    <h2>Column 3</h2>
                    <p>Content for column 3</p>
                </div> */}
            </div>


        </div>
    );
};

export default Home;
